import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.AUTHENTICATION.SET_TRANSFER_TOKEN,
  payload,
})
